import CampaignIcon from "@mui/icons-material/Campaign";
import permissions from "app/permissions";
import { DoctoralServicePath } from "utils/constants";
import ListDoctoralCampaigns from "./List";
import CreateDoctoralCampaign from "./Create";
import EditDoctoralCampaign from "./Edit";
import ShowDoctoralCampaign from "./Show";

export const resources = {
  isMenu: true,
  icon: <CampaignIcon />,
  name: `${DoctoralServicePath}doctoral-campaigns`,
  title: "Кампании",
  list: <ListDoctoralCampaigns />,
  create: <CreateDoctoralCampaign />,
  createPermission: permissions.canCreateDoctoralCampaigns,
  edit: <EditDoctoralCampaign />,
  editPermission: permissions.canUpdateDoctoralCampaigns,
  show: <ShowDoctoralCampaign />,
  permission: permissions.canPreviewDoctoralCampaigns,
};
